import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getBuyerDropdownFilter = createApi(`BuyerDropdownFilterSlice`,"GET");

const BuyerDropdownFilterSlice = createSlice({
  name: 'BuyerDropdownFilterSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getBuyerDropdownFilter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBuyerDropdownFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getBuyerDropdownFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default BuyerDropdownFilterSlice.reducer;